import { createBrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import NotFound from "../components/NotFound";
import LoadingSpinner from "../components/LoadingSpinner";
import AppLayout from "../components/AppLayout";
import { lazyLoad } from "../utils/lazyLoad";

// Lazy load components for code splitting with retry logic
const DashboardCalculator = lazyLoad(() =>
  import("../view/DashboardCalculator")
);
const DisplayConfiguration = lazyLoad(() =>
  import("../view/DisplayConfiguration")
);
const ScenarioSelection = lazyLoad(() => import("../view/ScenarioSelection"));
const DesiredMockup = lazyLoad(() => import("../view/DesiredMockup"));
const ImageViewer = lazyLoad(() => import("../view/ImageViewer"));
const SampleView = lazyLoad(() => import("../view/SampleView"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: (
          <Suspense
            fallback={<LoadingSpinner message="Loading Dashboard..." />}
          >
            <DashboardCalculator />
          </Suspense>
        ),
      },
      {
        path: "display-configuration",
        element: (
          <Suspense
            fallback={<LoadingSpinner message="Loading Configuration..." />}
          >
            <DisplayConfiguration />
          </Suspense>
        ),
      },
      {
        path: "scenario-selection",
        element: (
          <Suspense
            fallback={<LoadingSpinner message="Loading Scenarios..." />}
          >
            <ScenarioSelection />
          </Suspense>
        ),
      },
      {
        path: "desired-mockup",
        element: (
          <Suspense fallback={<LoadingSpinner message="Loading Mockup..." />}>
            <DesiredMockup />
          </Suspense>
        ),
      },
      {
        path: "image-viewer",
        element: (
          <Suspense fallback={<LoadingSpinner message="Loading Viewer..." />}>
            <ImageViewer />
          </Suspense>
        ),
      },
      {
        path: "sample-view",
        element: (
          <Suspense
            fallback={<LoadingSpinner message="Loading Sample View..." />}
          >
            <SampleView />
          </Suspense>
        ),
      },
    ],
  },
  // Add more routes here as needed
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
